<template>
  <div class="actress-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入ID" size="small" class="param-input" ></el-input>
      <el-input placeholder="请输入女优姓名" size="small" class="param-input" ></el-input>
      <el-input placeholder="请输入罩杯" size="small" class="param-input" ></el-input>
       <el-select  size="small" clearable v-model="params.enable">
          <el-option v-for="item in statusList" :value="item.value" :label="item.label" :key="item.value" ></el-option>
      </el-select>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" ></el-date-picker>
      <el-button type="primary" size="small" @click="getGoldList()">搜索</el-button>
      <el-button type="primary" size="small" @click="actressAction('add')">+ 新增女优</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableDate"  style="width: 100%" border  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="name" label="女优ID" align="center" fixed></el-table-column>
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column prop="name" label="中文名" align="center"></el-table-column>
      <el-table-column prop="name" label="照片" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="头像" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="出生日期" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="三围" align="center"></el-table-column>
      <el-table-column prop="name" label="罩杯" align="center"></el-table-column>
      <el-table-column prop="name" label="简介" align="center"></el-table-column>
      <el-table-column prop="name" label="作品" align="center"></el-table-column>
      <el-table-column prop="name" label="评分" align="center"></el-table-column>
      <el-table-column prop="name" label="人气" align="center"></el-table-column>
      <el-table-column prop="name" label="增加日期" align="center">
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status"></el-switch>
        </template>
      </el-table-column>
       <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="actressAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 编辑弹窗 -->
    <actress-action ref="actressAction"></actress-action>
  </div>
</template>
<script>
import baseConfig from '@/utils/serverUrlConfig'
import ActressAction from './components/actressAction'
import API from '@/api'
export default {
  data() {
    return {
      loading: false,
      tableDate: [1],
      total: 0,
      time: '',
      // 女优列表状态
      statusList:[
        {
          label: '全部',
          value: 1
        },
        {
          label: '开启',
          value: 2
        },
        {
          label: '关闭',
          value: 3
        }
      ],
      imgUrl: baseConfig.imgUrl,
      params: {
        pageNumber: 1,
        pageSize: 10,
        turnOn :false,
        enable: ''
      }
    }
  },
  created() {
    // this.getRankList()
  },
  components: {
    ActressAction
  },
  methods: {
    // 请求排行列表数据
    getRankList() {
      this.loading = true
      API.getRankList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 编辑弹窗
    actressAction(type,data){
      this.$refs.actressAction.open(type,data)
    },
     // 监听编辑成功过后重新拉去数据
    handlerRankList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getRankList()
    },
    // 编辑排行弹窗
     editToday(type,row) {
      this.$refs.editToday.open(type,row)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRankList()
    },
  }
}
</script>
